
import * as ipxRuntime$alr8785G5PtEJWKL44BNqFsAe9NNcwtGcQrItCLkmBw from '/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$alr8785G5PtEJWKL44BNqFsAe9NNcwtGcQrItCLkmBw, defaults: {} }
}
        